"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _includes = _interopRequireDefault(require("lodash/includes"));
var _castArray = _interopRequireDefault(require("lodash/castArray"));
var _isNode = _interopRequireDefault(require("../utils/isNode"));
var _default = function _default(keys, eventHandler) {
  var dependencies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _react.useEffect)(function () {
    if ((0, _isNode["default"])()) {
      return null;
    }
    var keyArray = (0, _castArray["default"])(keys);
    var handleOnEscape = function handleOnEscape(e) {
      if ((0, _includes["default"])(keyArray, e.key)) {
        eventHandler(e);
      }
    };
    document.addEventListener('keyup', handleOnEscape);
    return function () {
      return document.removeEventListener('keyup', handleOnEscape);
    };
  }, dependencies);
};
exports["default"] = _default;
//# sourceMappingURL=useKeyListener.js.map